import React, { useState } from "react";
import { AppContext } from "../hooks/useApp.js";

// Create a provider component
export const ApplicationProvider = ({ children }) => {
  // initialise menu state from local storage
  const [isMenuOpen, setIsMenuOpen] = useState(() => {
    const isOpen = localStorage.getItem("menuState");
    return isOpen === "true";
  });

  const toggleMenu = () => {
    localStorage.setItem("menuState", `${!isMenuOpen}`);
    setIsMenuOpen((prevState) => !prevState);
  };

  return <AppContext.Provider value={{ isMenuOpen, toggleMenu }}>{children}</AppContext.Provider>;
};
